module.exports = __webpack_public_path__ + "dist/media/icons.db866e2e.svg";